import React from 'react'
import './intro.component.css';
import photo from '../../../assets/images/2.jpg'
import Tag from '../../helpers/tag.component';

export default function Intro() {
  return (
    <div className='container body'>
      <div className='row name-header'>
        Niko Dojan
      </div>

      <section id='shortinfo'>
        <div className='row justify-content-center'>
          <div className='col-8 col-md-3 p-4 align-content-center'>
            <img src={photo} alt='Niko' className='photo'></img>
          </div>
          <div className='col-12 col-md-9 px-md-5 intro-text pb-3'>
            <p className='p-1 pl-md-5'>
            <span className='h5'>Software Developer with focus on C#</span><br></br>
              Hi, I'm Niko.<br></br>
              I studied Computer Science (Datamatiker) at Zealand in Roskilde.
              <br></br>
              At present I work as IT Developer in a software firm in Copenhagen, where I work on a SaaS product using .NET, TypeScript and other technologies.
            </p>    
            
          </div>
          <div className='row justify-content-center mt-3'>
              <Tag text='C#' cssClass='my-bg-purple'/>
              <Tag text='ASP.NET Core' cssClass='my-bg-purple'/>
              <Tag text='JS' cssClass='my-bg-yellow text-dark'/>
              <Tag text='Angular.js' cssClass='my-bg-yellow text-dark'/>
              <Tag text='SQL Server' cssClass='my-bg-purple'/>
              <Tag text='REST APIs' cssClass='my-bg-purple'/>
              <Tag text='SCRUM' cssClass='bg-info text-dark'/>
            </div>  
        </div>
      </section>

      <section id='openfor'>
        <p>

        </p>
      </section>

      <section id='social'>
        <div className='row text-center justify-content-center p-5 social-icon'>
          <div className='col-auto px-3' title='LinkedIn'>
          <a href="https://www.linkedin.com/in/nikodojan/" target='_blank' rel='noreferrer'>
          <i className="bi bi-linkedin"></i>
          </a>
          </div>
          <div className='col-auto px-3' title='twitter'>
          <a href="https://twitter.com/nikodojan" target='_blank' rel='noreferrer'>
            <i className="bi bi-twitter"></i>
          </a>
          </div>
          <div className='col-auto px-3' title='github'>
            <a href="https://github.com/nikodojan" target='_blank' rel='noreferrer'>
              <i className="bi bi-github"></i>
            </a>
          </div>
          {/* <div className='col-auto px-3'>
            <a href="https://github.com/nikodojan">
              <i class="bi bi-envelope"></i>
            </a>
          </div>      */}
        </div>
      </section>
    </div>
  )
}
